import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;900&display=swap');

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.typography.fontFamily};
    font-weight: ${theme.typography.fontWeights.regular};
    line-height: 1.6;
    color: ${theme.colors.neutral.darkGrey};
    background-color: ${theme.colors.neutral.white};
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 1.2;
    margin-bottom: ${theme.spacing.md};
  }

  h1 {
    font-size: ${theme.typography.sizes['5xl']};
    font-weight: ${theme.typography.fontWeights.bold};
  }

  h2 {
    font-size: ${theme.typography.sizes['4xl']};
  }

  h3 {
    font-size: ${theme.typography.sizes['3xl']};
  }

  h4 {
    font-size: ${theme.typography.sizes['2xl']};
  }

  h5 {
    font-size: ${theme.typography.sizes.xl};
  }

  h6 {
    font-size: ${theme.typography.sizes.lg};
  }

  p {
    margin-bottom: ${theme.spacing.md};
  }

  a {
    color: ${theme.colors.primary.blue};
    text-decoration: none;
    transition: color ${theme.transitions.base};
  }

  a:hover {
    color: ${theme.colors.primary.dark};
    text-decoration: underline;
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
    transition: all ${theme.transitions.base};
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    border: 1px solid #e0e0e0;
    border-radius: ${theme.borderRadius.md};
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    outline: none;
    transition: border-color ${theme.transitions.base};
  }

  input:focus, textarea:focus, select:focus {
    border-color: ${theme.colors.primary.blue};
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .container {
    width: 100%;
    max-width: ${theme.breakpoints.wide};
    margin: 0 auto;
    padding: 0 ${theme.spacing.md};
  }

  @media (min-width: ${theme.breakpoints.tablet}) {
    .container {
      padding: 0 ${theme.spacing.xl};
    }
  }

  @media (min-width: ${theme.breakpoints.desktop}) {
    h1 {
      font-size: 3.75rem;
    }
    
    h2 {
      font-size: ${theme.typography.sizes['5xl']};
    }
    
    h3 {
      font-size: ${theme.typography.sizes['4xl']};
    }
  }

  /* Utility classes */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;